import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { updateEmailAddress, getUser, koalaAnalyticsActions } from 'actions';
import { resetAppErrors } from 'actions/setters/updateAppErrors';
import EmailFormComponent from 'components/EmailForm/EmailFormComponent';
import { validators } from 'utils';
import { forms } from 'constants';
import appSelectors from 'selectors/app-selectors';
import { trimWhiteSpace } from 'utils/validation';

const fetchData = dispatch => dispatch(getUser());

export const validate = values => {
  const errors = {};
  if (!trimWhiteSpace(values.EmailAddress)) {
    errors.EmailAddress = 'Please enter your email address.';
  } else if (values.EmailAddress && values.EmailAddress.length > 100) {
    errors.EmailAddress = 'Please enter an email less than 100 characters.';
  } else if (!validators.isValidEmailAddress(values.EmailAddress)) {
    errors.EmailAddress = 'Please enter a valid email address.';
  }
  return errors;
};

const EmailFormContainer = reduxForm({
  form: forms.Email,
  validate,
})(EmailFormComponent);

const mapStateToProps = state => ({
  initialValues: state.app.user.data,
  status: {
    isFetching: appSelectors.isPersonalDetailsFetching(state),
    ...state.app.appErrors,
  },
});

export const mapDispatchToProps = dispatch => ({
  submitHandler: values => dispatch(updateEmailAddress(values)),
  fetchData: () => {
    fetchData(dispatch);
  },
  resetAppErrors: () => {
    dispatch(resetAppErrors());
  },
  trackPageView: (subtype, pageSection) => {
    koalaAnalyticsActions.trackPageView(subtype, pageSection)(dispatch);
  },
  trackLinkClick: (subtype, pageSection, eventValue) => {
    koalaAnalyticsActions.trackLinkClick(
      subtype,
      pageSection,
      eventValue,
    )(dispatch);
  },
});

const mergeProps = (stateProps, dispatchProps, ownProps) =>
  Object.assign({}, stateProps, dispatchProps, ownProps);

const EmailFormContainerConnected = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(EmailFormContainer);

EmailFormContainerConnected.fetchData = fetchData;

export default EmailFormContainerConnected;
